import {
  ON_SWITCH_AVAILABILITY_STATUS_AVAILABLE,
  ON_SWITCH_AVAILABILITY_STATUS_GENERIC,
  ON_SWITCH_WORKFLOW_RUN_STATUS_NO_RUN,
  ON_SWITCH_WORKFLOW_RUN_STATUS_LABEL_MAPPING,
} from './constants';

export const getIsOnSwitchFlow = (activation) => {
  if (!activation) return false;
  if (activation.parentRunId) return true;
  return [
    ON_SWITCH_AVAILABILITY_STATUS_AVAILABLE,
    ON_SWITCH_AVAILABILITY_STATUS_GENERIC,
  ].includes(activation.onSwitchAvailabilityStatus);
};

export const getOnSwitchWorkflowRunStatus = (task) => {
  if (!task?.run) return ON_SWITCH_WORKFLOW_RUN_STATUS_NO_RUN;
  return task.run.status;
};

export const getOnSwitchWorkflowRunStatusLabel = (status) => {
  return ON_SWITCH_WORKFLOW_RUN_STATUS_LABEL_MAPPING[status] || status;
};

export const getOnSwitchRunUrl = (scraperFactoryUrl, runId) => {
  if (!scraperFactoryUrl || !runId) return null;
  return `${scraperFactoryUrl}/inspect/${runId}`;
};
